<template>
    <div>
        <div v-on="expanded != 'true' ? { click: () => showAnswer()} : {}" :class="[expanded != 'true' ? 'cursor-pointer' : '']" class="flex w-full rounded-2xl relative z-10 mt-6" style="background-image: linear-gradient(to right, #63B3ED , #4FD1C5);">
            <div class=" text-white text-sm md:text-base py-4 pl-6 w-18/20 xl:w-19/20">
                {{ faq.question }}
            </div>
            <div class=" w-2/20 xl:w-1/20 justify-end">
                <svg v-if="expanded != 'true'" class="absolute r-0 mt-2 md:mt-3 p-1 "  width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path v-if="!active" class="dropdown-button" d="M16 9V23" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M23 16H9" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31Z" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
        </div>
                          
        <transition name="slide">
            <div v-if="active || expanded == 'true'" :active="active" :duration="500" class=" relative -mt-8 text-gray-600 text-sm md:text-base rounded-2xl border border-blue-400 ">
                <div class="pt-12 px-6 pb-4">
                    {{ faq.answer }}
                </div>
            </div>
        </transition>      
    </div>
</template>

<script>
    export default {
        name: 'FaqQuestion',
        props: ["faq", "expanded"],

        data() {   
            return {
              active:false,
            }
        },
        methods: {
            showAnswer() {
                if (this.active == true) {
                    this.active = false;
                } else {
                    this.active = true;
                }
            }
        },
        computed: { },
    }
</script>

<style> 

.slide-enter-active, .slide-leave-active  {
  transition: all .3s ease;
}
.slide-enter, .slide-leave-to
{
    opacity: 0;
    transform: translateY(-20%);
  
}
</style>